import {CommonRootState} from '../types';

/**
 * A feature flag, fail-closed. Flags come from /me for the session, and the
 * persisted slice can outlive the session token (seen on next: signed out,
 * the top bar still offered "Cartes de prévision"), so a flag only counts
 * while signed in.
 */
const isFlagOn = (state: CommonRootState, name: string) =>
  state.user?.token != null && (state.featureFlags?.flags?.[name] ?? false);

// The forecast-map browse pages, /forecast-maps/zones and /models, and
// their links in Map settings (backend flag `forecast_map_browse`, #327 P;
// was `forecast_maps`). Forecast itself is a mode of the unified /map and
// needs no flag. Fail-closed: a missing flag map (anon / not yet fetched)
// must hide the feature.
export const selectForecastMapBrowseEnabled = (state: CommonRootState) =>
  isFlagOn(state, 'forecast_map_browse');

// Forecast map composer/builder surface (backend flag `forecast_map_builder`).
// Defined ahead of the composer MR; same fail-closed rule.
export const selectForecastMapBuilderEnabled = (state: CommonRootState) =>
  isFlagOn(state, 'forecast_map_builder');

// Per session too: a leftover config showed signed-out visitors Stripe
// subscribe buttons whose checkout then failed with a 401.
export const selectStripeConfig = (state: CommonRootState) =>
  state.user?.token != null ? (state.featureFlags?.stripeConfig ?? null) : null;
